import { serviceIconSVG } from "../../../assets/SVGs/SVGs";
type Props = {
  data: any;
};

const ServiceRow = ({ data }: Props) => {
  return (
    <div className="grid items-center w-full grid-cols-3 gap-2 px-4 py-2 rounded-lg shadow-md max-3xl:grid-cols-2 ">
      <div className="flex items-center gap-2 max-3xl:col-span-2">
        <div className="flex items-center gap-2">
          {serviceIconSVG}
          <span className="text-sm font-semibold truncate max-4xl:text-xs whitespace-nowrap">
            {data?.name}
          </span>
        </div>
        <div className="w-2 h-2 max-4xl:h-[6px] max-4xl:w-[6px] rounded-full bg-[#A9AEF6]" />
      </div>

      <span className="col-span-2 text-sm text-color-primary whitespace-nowrap">
        {data?.pricing_options?.map((e: any) => (
          <div className="flex items-center gap-4 max-xl:gap-2">
            <div className="flex items-center gap-2 max-4xl:gap-1">
              <div className="w-2 h-2 max-4xl:h-[6px] max-4xl:w-[6px] rounded-full bg-[#9999A7]" />
              <span className="text-sm max-4xl:text-xs truncate text-color-primary min-w-[45px]">
                <span className="mx-1">{e?.duration}</span>
                <span className="text-[8px]">mins</span>
              </span>
            </div>
            <div className="flex items-center gap-2 max-4xl:gap-1">
              <div className="w-2 h-2 max-4xl:h-[6px] max-4xl:w-[6px] rounded-full bg-[#9999A7]" />
              <span className="text-sm max-4xl:text-xs truncate text-color-primary min-w-[45px]">
                <span className="mx-1">{e?.price}</span>
                <span className="text-[8px]">SR</span>
              </span>
            </div>
          </div>
        ))}
      </span>
    </div>
  );
};

export default ServiceRow;
